module.exports = __webpack_public_path__ + "img/Chart-Line-Color.ebc5cf2b.png";